export function RouteFallback() {
  return (
    <div className="route-fallback" aria-busy="true" aria-live="polite">
      <span className="visually-hidden">Loading…</span>
    </div>
  );
}
